import { render, staticRenderFns } from "./GC_TypesTable.vue?vue&type=template&id=b86987b6&scoped=true&"
import script from "./GC_TypesTable.vue?vue&type=script&lang=js&"
export * from "./GC_TypesTable.vue?vue&type=script&lang=js&"
import style0 from "./GC_TypesTable.vue?vue&type=style&index=0&id=b86987b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86987b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VDataTable,VDivider,VIcon,VTextField,VTooltip})
